export default __webpack_public_path__ + "static/media/subscribers.491023ed.svg";